module.exports = __webpack_public_path__ + "fa294aea607a4a6eea4db587c8d326e9.gif";